export default {
    G1:{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'logo',
        'siteSection': 'global nav',
        'buttonLocation': 'top'
    }, 
    G2:{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'nuestras prioridades', //e.g., 'our priorities'
        'siteSection': 'mobile global nav',
        'buttonLocation': 'top'
    }, 
    G3:{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'instituto de finanzas sostenibles (en inglés)', //e.g., 'our priorities'
        'siteSection': 'mobile global nav',
        'buttonLocation': 'top'
    }, 
    G4:{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'viviendas a precios asequibles',
        'siteSection': 'mobile global nav',
        'buttonLocation': 'top'
    },
    map:{

    },
    footer:{
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'footer', // e.g., "housing" 
        'siteSection': 'footer', // e.g., "housing"
    },
    "open-hamburger":{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'open hamburger',
        'siteSection': 'global nav',
        'buttonLocation': 'top'
    }, 
    "close-hamburger":{
        'event': 'navigation',
        'navigation': 'navigation',
        'navigationSection': 'global', 
        'navigationText': 'close hamburger',
        'siteSection': 'global nav',
        'buttonLocation': 'top'
    }
};